class DownloadsGrid {

	private readonly items;

	public constructor(grid: HTMLElement) {
		this.items = [...grid.querySelectorAll('.teaser-item')]

		if (this.items.length <= 6) {
			return;
		}
		this.intButton(grid)
		this.hideAllItems()
		this.showNextItems()
	}

	private intButton(grid: HTMLElement) {
		const button = <HTMLButtonElement>grid.querySelector('.show-more')
		button.onclick = () => {
			this.showNextItems()

			if (!this.items.some((item) => item.classList.contains('hidden'))) {
				button.remove();
			}
		}
	}

	private hideAllItems() {
		this.items.forEach((item) => {
			item.classList.add('hidden')
		})
	}

	private showNextItems() {
		let showItems: number = 6
		this.items.forEach((item) => {
			if (showItems === 0) {
				return
			}
			if (item.classList.contains('hidden')) {
				item.classList.remove('hidden');
				showItems--;
			}
		})
	}
}

const grids: NodeListOf<HTMLElement> = document.querySelectorAll('.downloads-grid');
grids.forEach((grid: HTMLElement) => new DownloadsGrid(grid))
